import Promise from 'promise';
import { axios } from '../_helpers';

export const libraryService = {
    getAllLibrary,
    getLibraryByUserRole
};

function getAllLibrary() {
    return axios.get('api/library/getAllLibrary').then((response) => {
        return response;
    }).catch((error) => {
        return Promise.reject(error);
    });
}

function getLibraryByUserRole(roleId,userId){
    let url = `api/collection/getcollectionbyuserrole/${roleId}/${userId}`;
    return axios.get(url).then((response) => {
        return response.data;
    }).catch((error) => {
        return Promise.reject(error);
    });
}



// WEBPACK FOOTER //
// ./src/_services/library.service.js